export default {
  meta: {
    title: '备选区域报表',
    url: '/home/config' // 埋点用，记录所属模块
  },
};
